import BaseDialog from "./BaseDialog";
import Image from "next/image";
import type { ProviderInfo } from "@/generated";
import { useIntegrationsNCLForm } from "./useIntegrationsNCLForm";

interface IIntegrationsNCLModal {
  isOpen: boolean;
  onClose: () => void;
  name: string;
  integrationType: string;
  configEndpoint: string;
  submitEndpoint: string;
  submitMethod?: "POST" | "PUT";
  credentialPayloadEndpoint?: string;
  providers?: ProviderInfo[];
  image?: string;
  onOAuthSelect?: (
    provider: ProviderInfo,
    connectionConfig?: Record<string, unknown>
  ) => Promise<boolean>;
}

export function IntegrationsNCLModal({
  isOpen,
  onClose,
  name,
  integrationType,
  configEndpoint,
  submitEndpoint,
  submitMethod = "POST",
  credentialPayloadEndpoint,
  providers,
  image,
  onOAuthSelect,
}: IIntegrationsNCLModal) {
  const { showPicker, body, description, footerActions, handleClose } =
    useIntegrationsNCLForm({
      isActive: isOpen,
      onClose,
      name,
      integrationType,
      configEndpoint,
      submitEndpoint,
      submitMethod,
      credentialPayloadEndpoint,
      providers,
      image,
      onOAuthSelect,
    });

  return (
    <BaseDialog
      title={
        showPicker ? (
          <span className="flex items-center gap-3">
            {image && (
              <span className="inline-flex w-7 h-7 rounded-lg bg-background border border-border/40 items-center justify-center p-1 shrink-0">
                <Image
                  width={18}
                  height={18}
                  alt={name}
                  src={image}
                  style={{
                    objectFit: "contain",
                    width: "100%",
                    height: "100%",
                  }}
                />
              </span>
            )}
            Connect {name}
          </span>
        ) : (
          `${name} connection`
        )
      }
      description={description}
      isOpen={isOpen}
      onOpenChange={(open) => {
        if (!open) handleClose();
      }}
      size="lg"
      footerActions={footerActions.map((action) => ({
        label: action.label,
        props: {
          variant: action.variant,
          onClick: action.onClick,
          loading: action.loading,
          disabled: action.disabled,
        },
      }))}
    >
      {body}
    </BaseDialog>
  );
}
